export const FEATURE_OVERRIDES = {
  enabled: false,
  overrides: {
    jackpot: true,
    tournaments: true,
    buyBonus: true,
    freebets: true,
    missions: false,
    chat: true,
  },
}

/**
 * Per-game force-enables, keyed by `gameCode` (the GAMES registry keys). Applied
 * on top of the backend flags and independently of `FEATURE_OVERRIDES.enabled`,
 * so a single feature can go live for some games without flipping everything for
 * every game. Chat is live for Defender and Howzzat.
 */
export const PER_GAME_FEATURE_OVERRIDES = {
  DEFENDER: { chat: true },
  HOWZZAT: { chat: true },
}

export const applyFeatureOverrides = (features, gameCode) => {
  const base = FEATURE_OVERRIDES.enabled
    ? { ...features, ...FEATURE_OVERRIDES.overrides }
    : features
  const perGame = PER_GAME_FEATURE_OVERRIDES[gameCode]
  if (!perGame) return base
  return { ...base, ...perGame }
}
